import { put, call, all, takeLatest } from 'redux-saga/effects';
import axiosConfig from '../../services/axiosConfig';
import {
  fetchDsrLogsSuccess,
  fetchDsrLogsFailure,
  createDsrLogSuccess,
  createDsrLogFailure,
  submitDsrLogSuccess,
  submitDsrLogFailure,
  updateDsrLogSectionsSuccess,
  updateDsrLogSectionsFailure,
  toggleDsrShiftSkippedSuccess,
  toggleDsrShiftSkippedFailure,
  fetchTechnicianLogSuccess,
  fetchTechnicianLogFailure,
  updateTechnicianLogSuccess,
  updateTechnicianLogFailure,
  fetchMaterialLogSuccess,
  fetchMaterialLogFailure,
  updateMaterialLogSuccess,
  updateMaterialLogFailure,
  fetchConsumablesLogSuccess,
  fetchConsumablesLogFailure,
  updateConsumablesLogSuccess,
  updateConsumablesLogFailure,
  fetchEquipmentUsageLogSuccess,
  fetchEquipmentUsageLogFailure,
  updateEquipmentUsageLogSuccess,
  updateEquipmentUsageLogFailure,
  fetchEhsLog,
  fetchEhsLogSuccess,
  fetchEhsLogFailure,
  updateEhsLogSuccess,
  updateEhsLogFailure,
  addEhsLogItemSuccess,
  addEhsLogItemFailure,
  deleteEhsLogItemSuccess,
  deleteEhsLogItemFailure,
  fetchAllEhsIssuesSuccess,
  fetchAllEhsIssuesFailure,
  fetchDowntimeLog,
  fetchDowntimeLogSuccess,
  fetchDowntimeLogFailure,
  updateDowntimeLogSuccess,
  updateDowntimeLogFailure,
  addDowntimeLogItemSuccess,
  addDowntimeLogItemFailure,
  deleteDowntimeLogItemSuccess,
  deleteDowntimeLogItemFailure,
  fetchDowntimeEquipmentsSuccess,
  fetchDowntimeEquipmentsFailure,
  fetchProductionLog,
  fetchProductionLogSuccess,
  fetchProductionLogFailure,
  updateProductionLogSuccess,
  updateProductionLogFailure,
  upsertProductionItemSuccess,
  upsertProductionItemFailure,
  deletePipeGroupSuccess,
  deletePipeGroupFailure,
  deleteProductionJointSuccess,
  deleteProductionJointFailure,
  updatePipeGroupSuccess,
  updatePipeGroupFailure,
  updateGroupItemSuccess,
  updateGroupItemFailure,
  updatePipeDataSuccess,
  updatePipeDataFailure,
} from './action';
import {
  FETCH_DSR_LOGS,
  CREATE_DSR_LOG,
  SUBMIT_DSR_LOG,
  UPDATE_DSR_LOG_SECTIONS,
  TOGGLE_DSR_SHIFT_SKIPPED,
  FETCH_TECHNICIAN_LOG,
  UPDATE_TECHNICIAN_LOG,
  FETCH_MATERIAL_LOG,
  UPDATE_MATERIAL_LOG,
  FETCH_CONSUMABLES_LOG,
  UPDATE_CONSUMABLES_LOG,
  FETCH_EQUIPMENT_USAGE_LOG,
  UPDATE_EQUIPMENT_USAGE_LOG,
  FETCH_EHS_LOG,
  UPDATE_EHS_LOG,
  ADD_EHS_LOG_ITEM,
  DELETE_EHS_LOG_ITEM,
  FETCH_ALL_EHS_ISSUES,
  FETCH_DOWNTIME_LOG,
  UPDATE_DOWNTIME_LOG,
  ADD_DOWNTIME_LOG_ITEM,
  DELETE_DOWNTIME_LOG_ITEM,
  FETCH_DOWNTIME_EQUIPMENTS,
  FETCH_PRODUCTION_LOG,
  UPDATE_PRODUCTION_LOG,
  UPSERT_PRODUCTION_ITEM,
  DELETE_PIPE_GROUP,
  DELETE_PRODUCTION_JOINT,
  UPDATE_PIPE_GROUP,
  UPDATE_GROUP_ITEM,
  UPDATE_PIPE_DATA,
} from './types';
import get from 'lodash/get';
import { notification } from 'antd';

/** Get all DSR logs */
function* fetchDsrLogs(payload) {
  try {
    if (payload.selectedProject == undefined) {
      yield put(fetchDsrLogsSuccess([]));
    } else {
      const { id: projectId } = payload.selectedProject;
      const { fromDate, toDate } = payload.dateObj || {};

      const queryParams = fromDate && toDate ? `&fromDate=${fromDate}&toDate=${toDate}` : '';
      const url = `/dsr-logs?projectId=${projectId}${queryParams}`;

      const res = yield axiosConfig.get(url);
      const response = get(res, ['data', 'data'], {});
      if (res.status === 200) {
        // if (response.length == 0) {
        //   notification.error({
        //     message: "No records found for this data range.",
        //   });
        // }
        yield put(fetchDsrLogsSuccess({ response }));
      } else {
        notification.error({
          message: 'Something went wrong. Please try again.',
        });
      }
    }
  } catch (error) {
    yield put(fetchDsrLogsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching DSR logs.',
      description: `${error}`,
    });
  }
}

/** Create/Get DSR log entry */
function* createDsrLog(payload) {
  try {
    const { projectId, logDate, sowId } = payload;
    const userEmail = JSON.parse(localStorage.getItem('user')).email;

    const url = `/dsr-log?projectId=${projectId}&logCreatedBy=${userEmail}&logDate=${logDate}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(createDsrLogSuccess({ response }));
      return response;
    } else {
      yield put(createDsrLogFailure());
      notification.error({
        message: 'Something went wrong while creating DSR log.',
      });
    }
  } catch (error) {
    yield put(createDsrLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while creating DSR log.',
      description: `${error}`,
    });
  }
}

/** Submit DSR log */
function* submitDsrLog(payload) {
  try {
    const { dsrLogData } = payload;

    const res = yield axiosConfig.put('/dsr-log', dsrLogData);

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(submitDsrLogSuccess({ response }));
      notification.success({
        message: 'DSR report submitted successfully!',
      });
    } else {
      yield put(submitDsrLogFailure());
      notification.error({
        message: 'Something went wrong while submitting DSR log.',
      });
    }
  } catch (error) {
    yield put(submitDsrLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while submitting DSR log.',
      description: `${error}`,
    });
  }
}

/** Update DSR log sections */
function* updateDsrLogSections(payload) {
  try {
    const { dsrLogId, sectionsSkipped, submissionStatus } = payload;

    const url = `/dsr-log/${dsrLogId}`;
    const data = {
      dsrLog: {
        ...(sectionsSkipped && { sectionsSkipped }),
        ...(submissionStatus && submissionStatus),
      },
    };

    const res = yield axiosConfig.put(url, data);

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(updateDsrLogSectionsSuccess({ response }));
      notification.success({
        message: 'Section status updated successfully!',
      });
    } else {
      yield put(updateDsrLogSectionsFailure());
      notification.error({
        message: 'Something went wrong while updating section status.',
      });
    }
  } catch (error) {
    yield put(updateDsrLogSectionsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating section status.',
      description: `${error}`,
    });
  }
}

/** Fetch technician log */
function* fetchTechnicianLog(payload) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = payload;

    const url = `/dsr-log-technician-logs?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(fetchTechnicianLogSuccess({ response }));
      return response;
    } else {
      yield put(fetchTechnicianLogFailure());
      notification.error({
        message: 'Something went wrong while fetching technician log.',
      });
    }
  } catch (error) {
    yield put(fetchTechnicianLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching technician log.',
      description: `${error}`,
    });
  }
}

/** Update technician log */
function* updateTechnicianLog(payload) {
  try {
    const { dsrLogTechnician } = payload;

    const res = yield axiosConfig.put('/dsr-log-technician-logs', { dsrLogTechnician });

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(updateTechnicianLogSuccess({ response }));
      notification.success({
        message: 'Technician log updated successfully!',
      });
    } else {
      yield put(updateTechnicianLogFailure());
      notification.error({
        message: 'Something went wrong while updating technician log.',
      });
    }
  } catch (error) {
    yield put(updateTechnicianLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating technician log.',
      description: `${error}`,
    });
  }
}

/** Fetch material log */
function* fetchMaterialLog(payload) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = payload;

    const url = `/dsr-log-materials?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(fetchMaterialLogSuccess({ response }));
      return response;
    } else {
      yield put(fetchMaterialLogFailure());
      notification.error({
        message: 'Something went wrong while fetching material log.',
      });
    }
  } catch (error) {
    yield put(fetchMaterialLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching material log.',
      description: `${error}`,
    });
  }
}

/** Update material log */
function* updateMateriallog(action) {
  try {
    const { type, ...apiPayload } = action;
    const res = yield axiosConfig.post('/dsr-log-material', apiPayload);

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(updateMaterialLogSuccess({ response }));
      notification.success({
        message: 'Material log updated successfully!',
      });
    } else {
      yield put(updateMaterialLogFailure());
      notification.error({
        message: 'Something went wrong while updating material log.',
      });
    }
  } catch (error) {
    yield put(updateMaterialLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating material log.',
      description: `${error}`,
    });
  }
}

/** Fetch consumables log */
function* fetchConsumablesLog(payload) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = payload;

    const url = `/dsr-log-consumables?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;

    const res = yield axiosConfig.get(url);

    if (res.status === 200) {
      const response = res.data;
      yield put(fetchConsumablesLogSuccess({ response }));
      return response;
    } else {
      yield put(fetchConsumablesLogFailure());
      notification.error({
        message: 'Something went wrong while fetching consumables log.',
      });
    }
  } catch (error) {
    yield put(fetchConsumablesLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching consumables log.',
      description: `${error}`,
    });
  }
}

/** Update consumables log */
function* updateConsumablesLog(payload) {
  try {
    const { dsrLogConsumables } = payload;

    const res = yield axiosConfig.post('/dsr-log-consumable', { dsrLogConsumables });

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(updateConsumablesLogSuccess({ response }));
      notification.success({
        message: 'Consumables log updated successfully!',
      });
    } else {
      yield put(updateConsumablesLogFailure());
      notification.error({
        message: 'Something went wrong while updating consumables log.',
      });
    }
  } catch (error) {
    yield put(updateConsumablesLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating consumables log.',
      description: `${error}`,
    });
  }
}

/** Fetch equipment usage log */
function* fetchEquipmentUsageLog(payload) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = payload;

    const url = `/dsr-log-equipment-usages?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);

    if (res.status === 200) {
      const response = res.data;
      yield put(fetchEquipmentUsageLogSuccess({ response }));
      return response;
    } else {
      yield put(fetchEquipmentUsageLogFailure());
      notification.error({
        message: 'Something went wrong while fetching equipment usage log.',
      });
    }
  } catch (error) {
    yield put(fetchEquipmentUsageLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while fetching equipment usage log.',
      description: `${error}`,
    });
  }
}

/** Update equipment usage log */
function* updateEquipmentUsageLog(payload) {
  try {
    const { dsrLogEquipmentUsage } = payload;

    const res = yield axiosConfig.post('/dsr-log-equipment-usage', { dsrLogEquipmentUsage });

    if (res.status === 200) {
      const response = get(res, ['data', 'data'], {});
      yield put(updateEquipmentUsageLogSuccess({ response }));
      notification.success({
        message: 'Equipment usage log updated successfully!',
      });
    } else {
      yield put(updateEquipmentUsageLogFailure());
      notification.error({
        message: 'Something went wrong while updating equipment usage log.',
      });
    }
  } catch (error) {
    yield put(updateEquipmentUsageLogFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occurred while updating equipment usage log.',
      description: `${error}`,
    });
  }
}

/** Fetch all EHS issues */
function* fetchAllEhsIssues() {
  try {
    const res = yield axiosConfig.get('/ehs-issue');
    if (res.status === 200) {
      const response = get(res, 'data', {});
      yield put(fetchAllEhsIssuesSuccess({ response }));
    } else {
      yield put(fetchAllEhsIssuesFailure());
      notification.error({ message: 'Something went wrong while fetching EHS issues.' });
    }
  } catch (error) {
    yield put(fetchAllEhsIssuesFailure());
    notification.error({
      message: 'A problem occurred while fetching EHS issues.',
      description: `${error}`,
    });
  }
}

/** Fetch EHS log */
function* fetchEhsLogSaga(payload) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = payload;
    const url = `/dsr-log-ehs-issue?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);
    if (res.status === 200) {
      const response = get(res, 'data', {});
      yield put(fetchEhsLogSuccess({ response }));
    } else {
      yield put(fetchEhsLogFailure());
      notification.error({ message: 'Something went wrong while fetching EHS log.' });
    }
  } catch (error) {
    yield put(fetchEhsLogFailure());
    notification.error({
      message: 'A problem occurred while fetching EHS log.',
      description: `${error}`,
    });
  }
}

/** Add EHS log item */
function* addEhsLogItemSaga(action) {
  try {
    const { ehsIssueId, projectId, dsrLogId, shift, logDate, userEmail, sowId } = action;

    if (!dsrLogId) {
      notification.error({ message: 'Cannot add EHS Issue: DSR Log is not properly initialized.' });
      yield put(addEhsLogItemFailure());
      return;
    }

    // Step 1: Link EHS issue to the project
    const projectIssuePayload = { ehsIssueId, projectId };
    const projectIssueRes = yield axiosConfig.post('/ehs-issue-project', projectIssuePayload);

    const ehsIssueProjectId = get(projectIssueRes, 'data.data.id');

    if (projectIssueRes.status !== 200 || !ehsIssueProjectId) {
      throw new Error('Failed to associate EHS issue with the project.');
    }

    // Step 2: Add the linked issue to the DSR log
    const dsrLogPayload = { dsrLogId, ehsIssueProjectId, shift };
    const dsrLogRes = yield axiosConfig.post('/dsr-log-ehs-issue', dsrLogPayload);

    if (dsrLogRes.status === 200) {
      yield put(addEhsLogItemSuccess());
      notification.success({ message: 'EHS issue added successfully!' });

      // Step 3: Refresh the EHS log data in the table
      yield put(fetchEhsLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      throw new Error('Failed to add EHS issue to the DSR log.');
    }
  } catch (error) {
    yield put(addEhsLogItemFailure());
    notification.error({
      message: 'A problem occurred while adding the EHS issue.',
      description: `${error}`,
    });
  }
}

/** Update EHS log */
function* updateEhsLogSaga(action) {
  try {
    // De-structure the incoming action to separate data for PUT and params for GET
    const { dsrLogEhsIssues, projectId, logDate, userEmail, shift, sowId } = action;

    // PUT request with only the necessary data
    const res = yield axiosConfig.put('/dsr-log-ehs-issue', { dsrLogEhsIssues });

    if (res.status === 200) {
      yield put(updateEhsLogSuccess());
      notification.success({ message: 'EHS log updated successfully!' });

      // Dispatch a clean fetch action with only the required params
      yield put(fetchEhsLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(updateEhsLogFailure());
      notification.error({ message: 'Something went wrong while updating EHS log.' });
    }
  } catch (error) {
    yield put(updateEhsLogFailure());
    notification.error({
      message: 'A problem occurred while updating EHS log.',
      description: `${error}`,
    });
  }
}

/** Delete EHS log item */
function* deleteEhsLogItemSaga(action) {
  try {
    const { projectId, id, logDate, userEmail, shift, sowId } = action;
    const url = `/dsr-log-ehs-issue?projectId=${projectId}&id=${id}`;
    const res = yield axiosConfig.delete(url);
    if (res.status === 200) {
      yield put(deleteEhsLogItemSuccess());
      notification.success({ message: 'EHS issue deleted successfully!' });
      // Refresh data with a clean payload
      yield put(fetchEhsLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(deleteEhsLogItemFailure());
      notification.error({ message: 'Something went wrong while deleting EHS issue.' });
    }
  } catch (error) {
    yield put(deleteEhsLogItemFailure());
    notification.error({
      message: 'A problem occurred while deleting EHS issue.',
      description: `${error}`,
    });
  }
}

/** Fetch all Downtime Equipments */
function* fetchDowntimeEquipmentsSaga(action) {
  try {
    const { projectId } = action;
    const res = yield axiosConfig.get(`/pih-equipments?projectId=${projectId}&searchKey=`);
    if (res.status === 200) {
      yield put(fetchDowntimeEquipmentsSuccess({ response: res.data.data }));
    } else {
      yield put(fetchDowntimeEquipmentsFailure());
      notification.error({ message: 'Failed to fetch equipments for downtime.' });
    }
  } catch (error) {
    yield put(fetchDowntimeEquipmentsFailure());
    notification.error({
      message: 'An error occurred while fetching downtime equipments.',
      description: `${error}`,
    });
  }
}

/** Fetch Downtime log */
function* fetchDowntimeLogSaga(action) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = action;
    const url = `/dsr-log-downtimes?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);
    if (res.status === 200) {
      yield put(fetchDowntimeLogSuccess({ response: res.data }));
    } else {
      yield put(fetchDowntimeLogFailure());
      notification.error({ message: 'Failed to fetch downtime log.' });
    }
  } catch (error) {
    yield put(fetchDowntimeLogFailure());
    notification.error({
      message: 'An error occurred while fetching the downtime log.',
      description: `${error}`,
    });
  }
}

/** Add Downtime log item */
function* addDowntimeLogItemSaga(action) {
  try {
    const { dsrLogDowntime, projectId, logDate, userEmail, shift, sowId } = action;
    const url = `/dsr-log-downtime?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&sowId=${sowId}`;
    const res = yield axiosConfig.post(url, { dsrLogDowntime: { ...dsrLogDowntime, shift } });
    if (res.status === 200) {
      yield put(addDowntimeLogItemSuccess());
      notification.success({ message: 'Downtime item added successfully!' });
      yield put(fetchDowntimeLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      throw new Error('Failed to add downtime log item.');
    }
  } catch (error) {
    yield put(addDowntimeLogItemFailure());
    notification.error({
      message: 'An error occurred while adding the downtime item.',
      description: `${error}`,
    });
  }
}

/** Update Downtime log */
function* updateDowntimeLogSaga(action) {
  try {
    const { dsrLogDowntime, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.put('/dsr-log-downtime', { dsrLogDowntime });
    if (res.status === 200) {
      yield put(updateDowntimeLogSuccess());
      notification.success({ message: 'Downtime log updated successfully!' });
      yield put(fetchDowntimeLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(updateDowntimeLogFailure());
      notification.error({ message: 'Failed to update downtime log.' });
    }
  } catch (error) {
    yield put(updateDowntimeLogFailure());
    notification.error({
      message: 'An error occurred while updating the downtime log.',
      description: `${error}`,
    });
  }
}

/** Delete Downtime log item */
function* deleteDowntimeLogItemSaga(action) {
  try {
    const { id, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.delete(`/dsr-log-downtime?id=${id}`);
    if (res.status === 200) {
      yield put(deleteDowntimeLogItemSuccess());
      notification.success({ message: 'Downtime item deleted successfully!' });
      yield put(fetchDowntimeLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(deleteDowntimeLogItemFailure());
      notification.error({ message: 'Failed to delete downtime item.' });
    }
  } catch (error) {
    yield put(deleteDowntimeLogItemFailure());
    notification.error({
      message: 'An error occurred while deleting the downtime item.',
      description: `${error}`,
    });
  }
}

/** Fetch Production log */
function* fetchProductionLogSaga(action) {
  try {
    const { projectId, logDate, userEmail, shift, sowId } = action;
    const url = `/dsr-log-production-joints?projectId=${projectId}&logDate=${logDate}&userEmail=${userEmail}&shift=${shift}&sowId=${sowId}`;
    const res = yield axiosConfig.get(url);
    if (res.status === 200) {
      yield put(fetchProductionLogSuccess({ response: res.data }));
    } else {
      yield put(fetchProductionLogFailure());
      notification.error({ message: 'Failed to fetch production log.' });
    }
  } catch (error) {
    yield put(fetchProductionLogFailure());
    notification.error({
      message: 'An error occurred while fetching the production log.',
      description: `${error}`,
    });
  }
}

/** Update Production log */
function* updateProductionLogSaga(action) {
  try {
    const {
      dsrLogProductionJoint,
      dayShiftComments,
      nightShiftComments,
      projectId,
      logDate,
      userEmail,
      shift,
      sowId,
    } = action;

    const payload = { dsrLogProductionJoint, dayShiftComments, nightShiftComments };
    console.log('Updating production log with payload:', payload);

    const res = yield axiosConfig.put('/dsr-log-production-joints', payload);
    if (res.status === 200) {
      yield put(updateProductionLogSuccess());
      notification.success({ message: 'Production log updated successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(updateProductionLogFailure());
      notification.error({ message: 'Failed to update production log.' });
    }
  } catch (error) {
    yield put(updateProductionLogFailure());
    notification.error({
      message: 'An error occurred while updating the production log.',
      description: `${error}`,
    });
  }
}

/** Upsert Production Item (Group or Joint) */
function* upsertProductionItemSaga(action) {
  try {
    const { productionJoint, projectId, logDate, userEmail, shift, sowId } = action;

    // productionJoint is an array, get the first item
    const item = productionJoint[0];
    const { id } = item;

    console.log('Upserting production item:', { productionJoint, item, id });

    let res;
    if (id) {
      // Update (PUT) existing item - using the correct API endpoint
      res = yield axiosConfig.put(`/production-joint/${id}`, item);
    } else {
      // Create (PUT) new item - send the wrapped object as expected by API
      res = yield axiosConfig.put('/production-joint', { productionJoint });
    }

    if (res.status === 200 || res.status === 201) {
      yield put(upsertProductionItemSuccess());
      notification.success({ message: 'Production item saved successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(upsertProductionItemFailure());
      notification.error({ message: 'Failed to save production item.' });
    }
  } catch (error) {
    yield put(upsertProductionItemFailure());
    notification.error({
      message: 'An error occurred while saving the production item.',
      description: `${error}`,
    });
  }
}

/** Delete Pipe Group */
function* deletePipeGroupSaga(action) {
  try {
    const { id, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.delete(`/production-joint/pipe-group?id=${id}`);
    if (res.status === 200) {
      yield put(deletePipeGroupSuccess());
      notification.success({ message: 'Pipe group deleted successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(deletePipeGroupFailure());
      notification.error({ message: 'Failed to delete pipe group.' });
    }
  } catch (error) {
    yield put(deletePipeGroupFailure());
    notification.error({
      message: 'An error occurred while deleting the pipe group.',
      description: `${error}`,
    });
  }
}

/** Delete Production Joint */
function* deleteProductionJointSaga(action) {
  try {
    const { id, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.delete(`/production-joint/pipe-description?id=${id}`);
    if (res.status === 200) {
      yield put(deleteProductionJointSuccess());
      notification.success({ message: 'Production joint deleted successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(deleteProductionJointFailure());
      notification.error({ message: 'Failed to delete production joint.' });
    }
  } catch (error) {
    yield put(deleteProductionJointFailure());
    notification.error({
      message: 'An error occurred while deleting the production joint.',
      description: `${error}`,
    });
  }
}

/** Update Pipe Group */
function* updatePipeGroupSaga(action) {
  try {
    const { id, pipeGroupData, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.put(`/production-joint/${id}`, pipeGroupData);

    if (res.status === 200) {
      yield put(updatePipeGroupSuccess());
      notification.success({ message: 'Pipe group updated successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(updatePipeGroupFailure());
      notification.error({ message: 'Failed to update pipe group.' });
    }
  } catch (error) {
    yield put(updatePipeGroupFailure());
    notification.error({
      message: 'An error occurred while updating the pipe group.',
      description: `${error}`,
    });
  }
}

/** Update Group Item */
function* updateGroupItemSaga(action) {
  try {
    const { id, groupItemData, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.put(`/production-joint/pipe-description/${id}`, groupItemData);

    if (res.status === 200) {
      yield put(updateGroupItemSuccess());
      notification.success({ message: 'Group item updated successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(updateGroupItemFailure());
      notification.error({ message: 'Failed to update group item.' });
    }
  } catch (error) {
    yield put(updateGroupItemFailure());
    notification.error({
      message: 'An error occurred while updating the group item.',
      description: `${error}`,
    });
  }
}

/** Update Pipe Data (Sub-string) */
function* updatePipeDataSaga(action) {
  try {
    const { id, pipeData, projectId, logDate, userEmail, shift, sowId } = action;
    const res = yield axiosConfig.put(`/production-joint/${id}`, pipeData);

    if (res.status === 200) {
      yield put(updatePipeDataSuccess());
      notification.success({ message: 'Pipe data updated successfully!' });
      yield put(fetchProductionLog({ projectId, logDate, userEmail, shift, sowId }));
    } else {
      yield put(updatePipeDataFailure());
      notification.error({ message: 'Failed to update pipe data.' });
    }
  } catch (error) {
    yield put(updatePipeDataFailure());
    notification.error({
      message: 'An error occurred while updating the pipe data.',
      description: `${error}`,
    });
  }
}

/** Toggle shift skipped (day / night / both) - PUT /dsr-log/toggle-shift-skipped */
function* toggleDsrShiftSkippedSaga({ dsrLogId, shift, skipStatus }) {
  try {
    const res = yield axiosConfig.put('/dsr-log/toggle-shift-skipped', {
      dsrLogId,
      shift,
      skipStatus,
    });
    if (res.status === 200) {
      const response = get(res, ['data', 'data'], res.data);
      yield put(toggleDsrShiftSkippedSuccess({ response }));
      notification.success({ message: 'Shift skip status updated.' });
    } else {
      yield put(toggleDsrShiftSkippedFailure());
      notification.error({ message: 'Failed to update shift skip status.' });
    }
  } catch (error) {
    yield put(toggleDsrShiftSkippedFailure());
    notification.error({
      message: 'Failed to update shift skip status.',
      description: get(error, 'message', `${error}`),
    });
  }
}

function* dsrWatcher() {
  yield takeLatest(FETCH_DSR_LOGS, fetchDsrLogs);
  yield takeLatest(CREATE_DSR_LOG, createDsrLog);
  yield takeLatest(SUBMIT_DSR_LOG, submitDsrLog);
  yield takeLatest(UPDATE_DSR_LOG_SECTIONS, updateDsrLogSections);
  yield takeLatest(TOGGLE_DSR_SHIFT_SKIPPED, toggleDsrShiftSkippedSaga);
  yield takeLatest(FETCH_TECHNICIAN_LOG, fetchTechnicianLog);
  yield takeLatest(UPDATE_TECHNICIAN_LOG, updateTechnicianLog);
  yield takeLatest(FETCH_MATERIAL_LOG, fetchMaterialLog);
  yield takeLatest(UPDATE_MATERIAL_LOG, updateMateriallog);
  yield takeLatest(FETCH_CONSUMABLES_LOG, fetchConsumablesLog);
  yield takeLatest(UPDATE_CONSUMABLES_LOG, updateConsumablesLog);
  yield takeLatest(FETCH_EQUIPMENT_USAGE_LOG, fetchEquipmentUsageLog);
  yield takeLatest(UPDATE_EQUIPMENT_USAGE_LOG, updateEquipmentUsageLog);
  yield takeLatest(FETCH_ALL_EHS_ISSUES, fetchAllEhsIssues);
  yield takeLatest(FETCH_EHS_LOG, fetchEhsLogSaga);
  yield takeLatest(ADD_EHS_LOG_ITEM, addEhsLogItemSaga);
  yield takeLatest(UPDATE_EHS_LOG, updateEhsLogSaga);
  yield takeLatest(DELETE_EHS_LOG_ITEM, deleteEhsLogItemSaga);
  yield takeLatest(FETCH_DOWNTIME_EQUIPMENTS, fetchDowntimeEquipmentsSaga);
  yield takeLatest(FETCH_DOWNTIME_LOG, fetchDowntimeLogSaga);
  yield takeLatest(ADD_DOWNTIME_LOG_ITEM, addDowntimeLogItemSaga);
  yield takeLatest(UPDATE_DOWNTIME_LOG, updateDowntimeLogSaga);
  yield takeLatest(DELETE_DOWNTIME_LOG_ITEM, deleteDowntimeLogItemSaga);
  yield takeLatest(FETCH_PRODUCTION_LOG, fetchProductionLogSaga);
  yield takeLatest(UPDATE_PRODUCTION_LOG, updateProductionLogSaga);
  yield takeLatest(UPSERT_PRODUCTION_ITEM, upsertProductionItemSaga);
  yield takeLatest(DELETE_PIPE_GROUP, deletePipeGroupSaga);
  yield takeLatest(DELETE_PRODUCTION_JOINT, deleteProductionJointSaga);
  yield takeLatest(UPDATE_PIPE_GROUP, updatePipeGroupSaga);
  yield takeLatest(UPDATE_GROUP_ITEM, updateGroupItemSaga);
  yield takeLatest(UPDATE_PIPE_DATA, updatePipeDataSaga);
}

function* dsrSagas() {
  yield all([call(dsrWatcher)]);
}

export default dsrSagas;
